module.exports = __webpack_public_path__ + "static/media/image-upload.0292e398.svg";